import { AdminPanelSettings, History } from "@mui/icons-material";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { FramerTooltip } from "@ryde/controls";
import { useApplication } from "@ryde/redux";
import {
  logoSelector,
  profileScopeAtom,
  SINGLE_KEY,
  TOOLTIP_DELAY_BUTTONS,
  usePrefixedRouting,
  useUserActionsHistoryBell,
} from "@ryde/shared";

import { HeaderTopLangSwitch } from "./header.top.lang-switch";
import {
  HeaderTopRightStyled,
  HeaderTopUserActionsHistoryButtonStyled,
} from "./header.top.styled";

export const HeaderTopRight: FC<PropsWithChildren> = () => {
  const scope = useRecoilValue(profileScopeAtom);
  const logoPath = useRecoilValue(logoSelector);
  const { isAdminApp, isMainApp } = useApplication();
  const { prefix } = usePrefixedRouting();
  const { t } = useTranslation();
  const companyName = scope ? scope.companyName : t("errors.noCompanyChosen");
  const {
    onMenuItemClick: onUserActionsHistoryClick,
    isUserActionsHistoryDrawerOpened,
  } = useUserActionsHistoryBell();

  return (
    <HeaderTopRightStyled>
      {isMainApp && (
        <FramerTooltip
          content={t("userActionsHistory.openRecentActivity")}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <HeaderTopUserActionsHistoryButtonStyled
            className="header-top-right__user-actions-history"
            size="small"
            aria-label={t("userActionsHistory.openRecentActivity")}
            aria-pressed={isUserActionsHistoryDrawerOpened}
            onClick={onUserActionsHistoryClick}
          >
            <History fontSize="small" aria-hidden />
          </HeaderTopUserActionsHistoryButtonStyled>
        </FramerTooltip>
      )}
      <HeaderTopLangSwitch />
      <div className="header-top-right__company">
        <span className="header-top-right__company-name">{companyName}</span>
        <Link
          to={prefix}
          className="header-top-right__nav-logo"
          title={
            scope
              ? `${scope.companyName} (${t("general.ID")}:${scope.companyId}, ${t(`role.${SINGLE_KEY}`)}: ${scope.role})`
              : t("errors.noCompanyChosen")
          }
        >
          {!isAdminApp && (
            <img
              className="header-top-right__logo-image"
              src={logoPath}
              alt="logo"
            />
          )}
          {isAdminApp && <AdminPanelSettings />}
        </Link>
      </div>
    </HeaderTopRightStyled>
  );
};
